/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable prefer-arrow/prefer-arrow-functions */
/* eslint-disable space-before-function-paren */
import {
    HttpClient,
    HttpErrorResponse,
    HttpHeaders,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IAddMembership } from 'app/interface/i-add-Membership';
import { FetchData as utility } from 'app/shared/generalMethods';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root',
})
export class MembershipRegistrationService {
    private headers: HttpHeaders;
    private options = {};
    private user: any;
    private parentIdOrUid = '';
    private serverUrl = environment.apiUrlNewCall;
    private serverCache = environment.apiUrlCache;
    private addMembership: IAddMembership;

    constructor(private http: HttpClient, private _utility: utility) {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        this.headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        this.options = { headers: this.headers };
        this.parentIdOrUid = this._utility.parentId;
    }

    addMembershipRegistration(
        membershipObject: IAddMembership
    ): Observable<any> {
        const body = [];
        const url = this.serverUrl + 'membership-registration/enroll';
        body.push(membershipObject);
        return this.http
            .post(url, body, this.options)
            .pipe(catchError(this.handleError));
    }

    private handleError(error: HttpErrorResponse): Observable<never> {
        if (error.error instanceof ErrorEvent) {
            // A client-side or network error occurred
            console.error('An error occurred:', error.error.message);
        } else {
            // The backend returned an unsuccessful response code
            console.error(
                `Backend returned code ${error.status}, ` +
                    `body was: ${error.error}`
            );
        }
        // Return an observable with a user-facing error message
        return throwError('Something went wrong. Please try again later.');
    }
}
